import { FC, lazy, Suspense } from 'react';
import './App.css';
import Layout from './components/landing-layout/LandingLayout';
import Main from './pages/main/Main';
import { JurisdictionContextProvider } from './contexts/jurisdiction-context';
import { BrowserRouter as Router, Route, Switch, } from 'react-router-dom';
import { BASE_URL } from './constants';
import { AppContextProvider } from './contexts/app.context';
import { ProtectedRoute } from './router/ProtectedRoute';
import { LoadingFullScreen } from './components/loading';
import { AuthContextProvider } from './contexts/auth.context';

const Login = lazy(() => import('./pages/login/Login'));
const EmailVerification = lazy(() => import('./pages/verification/EmailVerification'));
const PhoneVerification = lazy(() => import('./pages/verification/PhoneVerification'));
const RequestSuccess = lazy(() => import('./pages/request-success/RequestSuccess'));

const App: FC = () => {

    return (
        <AppContextProvider>
            <Router>
                <JurisdictionContextProvider>
                    <AuthContextProvider>
                        <Layout>
                            <div className="rounded-sm _bg-white my-4 sm:my-6 lg:my-8 theme-page flex justify-center">
                                <div className="w-full lg:w-[930px]">
                                    <Suspense fallback={<LoadingFullScreen />}>
                                        <Switch>
                                            <Route exact path={`${BASE_URL}/:slug/login`}>
                                                <Login />
                                            </Route>
                                            <Route exact path={`${BASE_URL}/:slug/email-verification`}>
                                                <EmailVerification />
                                            </Route>
                                            <Route exact path={`${BASE_URL}/:slug/phone-verification`}>
                                                <PhoneVerification />
                                            </Route>
                                            <ProtectedRoute exact path={`${BASE_URL}/:slug`}>
                                                <Main />
                                            </ProtectedRoute>
                                            <ProtectedRoute exact path={`${BASE_URL}/:slug/success`}>
                                                <RequestSuccess />
                                            </ProtectedRoute>
                                            <ProtectedRoute exact path={`${BASE_URL}/:version/:slug`}>
                                                <Main />
                                            </ProtectedRoute>
                                            <ProtectedRoute exact path={`${BASE_URL}/:version/:slug/success`}>
                                                <RequestSuccess />
                                            </ProtectedRoute>
                                        </Switch>
                                    </Suspense>
                                </div>
                            </div>
                        </Layout>
                    </AuthContextProvider>
                </JurisdictionContextProvider>
            </Router>
        </AppContextProvider>
    );
}

export default App;
